<div class="text-center" style="background-color: whitesmoke">
  <strong>California Investigative Consumer Report
  Advisory Notice</strong>
</div>

<mat-dialog-content>
  <div class="text-justify my-4">
    You are applying to live in a home managed by Tricon. Our screening process includes obtaining an investigative consumer report for all applicants, which you are consenting to as part of your application. This means that an investigative consumer report will be made regarding your character, general reputation, personal characteristics, or mode of living. The name and address of the agency that will prepare the report is:
  </div>
  <div class="text-left ml-4 my-2">
    <div class="my-4">
      <strong>TransUnion Rental Screening Solutions, Inc. (TURSS)</strong>
      <div>
        <p>P.O. Box 800</p>
        <p>Woodlyn, PA 19094</p>
        <p>(800) 230-9376</p>
        <p>TURSSDispute@transunion.com</p>
      </div>
    </div>
    <div class="mt-2">
      <strong>TURSS obtained information from the following consumer reporting agency which maintains information about you:</strong>
      <div>
        <p>TransUnion Consumer Solutions</p>
        <p>P.O. Box 2000</p>
        <p>Chester, PA. 19022-2000</p>
        <p>(800) 916-8800</p>
      </div>
    </div>
  </div>
  <div class="my-2">
    If you select Yes, you will receive a copy of the report within three days.
  </div>
  <div  class="text-justify mt-2">
    Under Section 1786.22 of the California Investigative Consumer Reporting Agencies Act, you have the right upon request and verification of your identity by TURSS through the submission of proper identification: (1) to visually inspect all files maintained by TURSS regarding you; (2) to request a copy of your file be provided to you by certified mail at a specified address; and (3) to request that a summary of all information contained in your files be provided by telephone. You also have the right to receive a list of the recipients of any investigative consumer report about you furnished by TURSS within the three (3)-year period preceding your request, including the name, address and telephone number of such recipients. You may also request the dates, original payees, and amounts of any checks or charges upon which any adverse characterization of you is based.
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-col justify-center w-full">
  <div class="w-full">
      <button mat-flat-button style="width:100%" class="mt-4" color="primary" mat-dialog-close="close">Close</button>
  </div>
</mat-dialog-actions>
